/**
 * Captures and persists the `auth_secret` query parameter for Front sidebar
 * plugin authentication.
 *
 * The Front sidebar embeds our app in a cross-site iframe. Because cookies
 * default to SameSite=Strict, the backend's AuthSecretCookieMiddleware must
 * see the secret on EVERY request (not just login) so it can set cookies to
 * SameSite=None. We capture the secret from the initial URL and store it in
 * sessionStorage so that baseQuery can attach it as a header on all requests.
 *
 * This module is imported as a side-effect in index.tsx so it runs before
 * React mounts and before SessionManager fires check-session.
 */

const STORAGE_KEY = 'front_auth_secret';

// Capture auth_secret from URL on initial load
const params = new URLSearchParams(window.location.search);
const authSecret = params.get('auth_secret');
if (authSecret) {
  try {
    sessionStorage.setItem(STORAGE_KEY, authSecret);
  } catch {
    // sessionStorage may be blocked in cross-site iframes (Safari ITP, Firefox ETP)
  }
}

/**
 * Returns the stored Front auth secret, or null if not in a Front sidebar context.
 */
export function getFrontAuthSecret(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? authSecret;
  } catch {
    return authSecret;
  }
}
